import {SOCIAL_NETWORK_DISPLAY_NAME} from '@/config/socialNetwork';

function getNetworkDisplayName(network: string | null | undefined): string {
  if (network == null) {
    return 'Content';
  }
  return SOCIAL_NETWORK_DISPLAY_NAME[network] ?? network.toUpperCase();
}

export default getNetworkDisplayName;
